import {Swiper} from 'swiper'
import {FreeMode, Navigation, Pagination} from 'swiper/modules'
import {breakpointUp, getScreenWidth} from '../../utils/breakpoints'

let secondCarouselSwiper;
let dupedSlidesAdded = false;
const basicCarouselSlides = []



window.initBasicCarousel = () => {
  const sliderContainers = document.querySelectorAll('.js--basic-carousel')
  sliderContainers.forEach((sliderContainer, index) => {

    let sliderSwiper = sliderContainer.querySelector('.swiper')
    let nextBtn = $(sliderContainer).find('.swiper-nav-next')
    let prevBtn = $(sliderContainer).find('.swiper-nav-prev')
    let paginationContainer = sliderContainer.querySelector('.swiper-pagination');
    if (basicCarouselSlides[index]) {
      basicCarouselSlides[index].destroy(true, true); // Destroy Swiper instance
      basicCarouselSlides[index] = null; // Set swiper to null
      $(sliderContainer).find('.swiper-slide').removeAttr('style');
      $(sliderContainer).find('.swiper-wrapper').removeAttr('style');
      nextBtn.off('click'); // Remove click listener
      prevBtn.off('click'); // Remove click listener
    }


    basicCarouselSlides[index] = new Swiper(sliderSwiper, {
      modules: [Navigation, Pagination],
      spaceBetween: 8,
      slidesPerView: "auto",
      centeredSlides: false,
      // navigation: {
      //   nextEl: nextBtn,
      //   prevEl: prevBtn
      // },

      loop: false,
      cssMode: false,
      rewind: false,
      breakpoints: {
        992: {
          cssMode: false,
        },
      },
    })
    nextBtn.on('click', () => {
      if (basicCarouselSlides[index].isEnd) {
        basicCarouselSlides[index].slideTo(0);
      } else {
        basicCarouselSlides[index].slideNext();
      }
    });

    prevBtn.on('click', () => {
      if (basicCarouselSlides[index].isBeginning) {
        basicCarouselSlides[index].slideTo(basicCarouselSlides[index].slides.length - 1);
      } else {
        basicCarouselSlides[index].slidePrev();
      }
    });

  })


}

window.initSecondCarousel = () => {

  const latestSliderContainers = document.querySelectorAll('.js--latest-carousel')

  latestSliderContainers.forEach((latestSliderContainer) => {

    let sliderSwiper = latestSliderContainer.querySelector('.swiper')
    let nextBtn = latestSliderContainer.querySelector('.swiper-nav-next')
    let prevBtn = latestSliderContainer.querySelector('.swiper-nav-prev')

    // Find the maximum height of the blocks
    let maxBlockHeight = 0;
    const blocks = latestSliderContainer.querySelectorAll('.content');

    blocks.forEach((block) => {
      const blockHeight = block.offsetHeight;
      maxBlockHeight = Math.max(maxBlockHeight, blockHeight);
    });

    // Set the maximum height for all slides
    // const slides = latestSliderContainer.querySelectorAll('.swiper-slide');
    // slides.forEach((slide) => {
    //   const content = slide.querySelector('.content');
    //   content.style.height = maxBlockHeight + 'px';
    // });

    secondCarouselSwiper = new Swiper(sliderSwiper, {
      modules: [FreeMode, Navigation, Pagination],
      spaceBetween: 8,
      slidesPerView: 1.1,
      centeredSlides: false,
      freeMode: {
        enabled: false
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
      },
      loop: true,
      autoHeight: true,
    })

  })


}

function destroySecondCarousel() {

  if (secondCarouselSwiper) {
    secondCarouselSwiper.destroy(true, true);
    secondCarouselSwiper = null;
  }
}

function handleResize() {
  const screenWidth = window.screen.width;
  if (screenWidth >= 992) {
    destroySecondCarousel();
  } else {
    initSecondCarousel();
  }
}

// Call on page load
handleResize();

$(document).ready(() => {
  initBasicCarousel();
})

// Call on window resize
window.addEventListener('resize', handleResize);
